/* eslint-disable react/no-deprecated */
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));

// Never use the legacy cache-first SW — it pins stale hashed chunks after
// deploys (Safari ChunkLoadError → "Loading failed"). Keep firebase messaging
// SW registration in app.js only.
serviceWorker.unregister();
if (typeof caches !== 'undefined' && caches.keys) {
  caches.keys().then((keys) => Promise.all(keys.map((k) => caches.delete(k)))).catch(() => {});
}
// Clear one-shot chunk-reload guard after a healthy boot.
try {
  sessionStorage.removeItem('lg_admin_chunk_reload');
} catch (_) {
  /* ignore */
}
